import React, {
  useState,
} from 'react';
import { Card } from 'react-bootstrap';
import { auth } from '../../Auth/Auth';
import { PageWrapper } from '../../ui/PageWrapper';
import { canViewAllContent } from '../../utils/userActionUtils';
import { UploadFilesModalAudio } from '../UploadFilesModal/UploadFilesModalAudio';
import { AudioLibraryContainer } from './AudioLibraryContainer/AudioLibraryContainer';
import { AudiosProvider, useRefetchAudio } from './AudioLibraryContainer/AudiosProvider/AudiosProvider';
import { UploadAudio } from './AudioLibraryContainer/UploadAudio/UploadAudio';

function BulkUploadAudioWrapper({ isOpen, onClose }) {
  const refetchAudio = useRefetchAudio();

  const handleUploaded = () => {
    refetchAudio();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <UploadFilesModalAudio
      onUploaded={handleUploaded}
      onClose={onClose}
    />
  );
}

export function AudioLibraryPage(props) {
  const {
    history,
  } = props;

  const [isUploadModalShown, setIsUploadModalShown] = useState(false);
  const [isBulkUploadModalShown, setIsBulkUploadModalShown] = useState(false);

  const user = auth.getUser();
  const authorId = canViewAllContent(user) ? undefined : user.id;
  const showUploadModal = () => setIsUploadModalShown(true);
  const showBulkUploadModal = () => setIsBulkUploadModalShown(true);

  const pageLayout = {
    header: {
      title: 'Audio',
      settings: 'admin',
    },
    sidebar: {
      nav: [
        {
          title: 'Back',
          href: '/home/',
          action: history.length > 1 && document.referrer !== window.location.href
            ? () => {
              window.history.back();
            } : null,
          variant: 'secondary',
        },
        {
          title: 'Upload audio',
          action: showUploadModal,
          variant: 'primary',
        },
        {
          title: 'Bulk Upload Audio',
          action: showBulkUploadModal,
          variant: 'primary',
        },
      ],
    },
  };

  const handleUpload = () => {
    setIsUploadModalShown(false);
  };

  const handleCancel = () => {
    setIsUploadModalShown(false);
  };

  const handleBulkUploadClose = () => {
    setIsBulkUploadModalShown(false);
  };

  return (
    <PageWrapper
      {...props}
      page={pageLayout}
    >
      <AudiosProvider initialPageSize={10} authorId={authorId}>
        <Card className="d-block">
          <Card.Body>
            <Card.Title className="text-center">
              Audio
            </Card.Title>
            <AudioLibraryContainer user={user} />
          </Card.Body>
        </Card>
        {
          isUploadModalShown && (
            <UploadAudio
              onUpload={handleUpload}
              onCancel={handleCancel}
            />
          )
        }
        <BulkUploadAudioWrapper
          isOpen={isBulkUploadModalShown}
          onClose={handleBulkUploadClose}
        />
      </AudiosProvider>
    </PageWrapper>
  );
}
